import styled from 'styled-components';
import { mobileThreshold } from '../../Constants/layoutValues';

export const ExternalWrapper = styled('div')`
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: center;
	@media print {
		width: 100%;
		font-size: 30px;
	}
	@media (max-width: ${mobileThreshold}px) {
		width: 100%;
	}
`;

export const CvWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	@media screen {
		font-size: 1.15em;
		line-height: 1.6em;
		max-width: 1600px;
	}

	@media print {
		font-weight: 100;
		font-size: 9px;
		line-height: 11px;
		margin-left: 0;
		margin-right: 0;
	}
	@media (max-width: ${mobileThreshold}px) {
		width: 100%;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}
`;

export const BodySection = styled('div')`
	display: flex;
	flex-direction: column;
	padding-left: 2rem;
	padding-right: 2rem;
	@media print {
		padding-left: 0;
		padding-right: 0;
	}
	@media (max-width: ${mobileThreshold}px) {
		padding-left: 0;
		padding-right: 0;
	}
`;
